"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinCluster = void 0;
const marker_clusterer_1 = require("@react-google-maps/marker-clusterer");
class PinClusterIcon extends marker_clusterer_1.ClusterIcon {
    constructor(cluster, stopPropagation = true) {
        super(cluster, []);
        this.pane = null;
        this.div = document.createElement('div');
        this.stopPropagation = stopPropagation;
    }
    select() {
        google.maps.event.trigger(this, 'select');
    }
    deselect() {
        google.maps.event.trigger(this, 'deselect');
    }
    useStyle(sums) {
        this.sums = sums;
    }
    show() {
        if (this.div && this.center) {
            const pos = this.getPosFromLatLng(this.center);
            this.div.style.cssText = this.createCss(pos);
            this.div.style.display = '';
        }
        this.visible = true;
    }
    createCss(pos) {
        return `
      cursor: pointer;
      position: absolute;
      top: ${pos.y}px;
      left: ${pos.x}px;
    `;
    }
    onAdd() {
        if (typeof google !== 'object')
            return;
        let cMouseDownInCluster;
        let cDraggingMapByCluster;
        if (this.visible) {
            this.show();
        }
        if (!this.pane) {
            this.pane = this.getPanes()
                .overlayMouseTarget;
            this.pane.appendChild(this.div);
        }
        this.div.className = this.className;
        // Fix for Issue 157
        this.boundsChangedListener = google.maps.event.addListener(
        // @ts-ignore
        this.getMap(), 'boundschanged', function boundsChanged() {
            cDraggingMapByCluster = cMouseDownInCluster;
        });
        this.div.addEventListener('mousedown', function onMouseDown() {
            cMouseDownInCluster = true;
            cDraggingMapByCluster = false;
        });
        this.div.addEventListener('click', (event) => {
            cMouseDownInCluster = false;
            if (!cDraggingMapByCluster) {
                const markerClusterer = this.cluster.getClusterer();
                google.maps.event.trigger(markerClusterer, 'click', this.cluster);
                google.maps.event.trigger(markerClusterer, 'clusterclick', this.cluster); // deprecated name
                // The default click handler follows. Disable it by setting
                // the zoomOnClick property to false.
                if (markerClusterer.getZoomOnClick()) {
                    // Zoom into the cluster.
                    const maxZoom = markerClusterer.getMaxZoom();
                    const bounds = this.cluster.getBounds();
                    // @ts-ignore
                    markerClusterer.getMap().fitBounds(bounds);
                    // There is a fix for Issue 170 here:
                    setTimeout(function timeout() {
                        // @ts-ignore
                        markerClusterer.getMap().fitBounds(bounds);
                        // Don't zoom beyond the max zoom level
                        if (maxZoom !== null &&
                            // @ts-ignore
                            markerClusterer.getMap().getZoom() > maxZoom) {
                            // @ts-ignore
                            markerClusterer.getMap().setZoom(maxZoom + 1);
                        }
                    }, 100);
                }
                if (this.stopPropagation) {
                    // Prevent event propagation to the map:
                    event.cancelBubble = true;
                    if (event.stopPropagation) {
                        event.stopPropagation();
                    }
                }
            }
        });
    }
    onRemove() {
        if (typeof google !== 'object' || !this.div)
            return;
        this.hide();
        if (this.boundsChangedListener !== null) {
            google.maps.event.removeListener(this.boundsChangedListener);
        }
        google.maps.event.clearInstanceListeners(this.div);
    }
}
class PinCluster extends marker_clusterer_1.Cluster {
    constructor(markerClusterer) {
        super(markerClusterer);
        this.index = -1;
        this.clusterIcon = new PinClusterIcon(this, markerClusterer.stopPropagation);
    }
    deselect() {
        this.clusterIcon.deselect();
    }
    select() {
        this.clusterIcon.select();
    }
}
exports.PinCluster = PinCluster;
class PinClusterer extends marker_clusterer_1.Clusterer {
    constructor(map, optMarkers = [], optOptions = {}) {
        super(map, optMarkers, optOptions);
        this.stopPropagation = true;
    }
    setMap(map) {
        google.maps.OverlayView.prototype.setMap.call(this, map);
    }
    // It's just fixed version of addToClosestCluster original method
    // To use PinCluster instead
    // @Override
    addToClosestCluster(marker) {
        let cluster;
        let distance = 40000; // Some large number
        let clusterToAddTo = null;
        for (let i = 0; i < this.clusters.length; i++) {
            cluster = this.clusters[i];
            const center = cluster.getCenter();
            const position = marker.getPosition();
            if (center && position) {
                const d = this.distanceBetweenPoints(center, position);
                if (d < distance) {
                    distance = d;
                    clusterToAddTo = cluster;
                }
            }
        }
        if (clusterToAddTo === null || clusterToAddTo === void 0 ? void 0 : clusterToAddTo.isMarkerInClusterBounds(marker)) {
            clusterToAddTo.addMarker(marker);
        }
        else {
            cluster = new PinCluster(this);
            cluster.addMarker(marker);
            this.clusters.push(cluster);
        }
    }
    // Prevent faults from unloading google object on unmounting
    redraw() {
        if (typeof google === 'object') {
            super.redraw();
        }
    }
}
exports.default = PinClusterer;
//# sourceMappingURL=PinClusterer.js.map